import {Messenger} from './Messenger';

export class DefaultMessenger extends Messenger {

}